import React from "react";
import { testimonials } from "../data/landing";
import { SectionHead } from "./SectionHead";
export function Testimonials() {
  return <section className="card" data-id="element-142" data-mp="3kqw1mcxm2ocf">
      <SectionHead kicker="DEPOIMENTOS" title="O que dizem os profissionais" subtitle="Impressões de quem trabalha todos os dias com o movimento do idoso." data-id="element-143" data-mp="3fznvbprkvj3h" />
      <div className="tgrid" data-id="element-144" data-mp="3ayqdjeahcr2i">
        {testimonials.map(t => <figure className="tst" key={t.pain} data-id="element-145" data-mp="370kaohcrivmv">
            <span className="tpain" data-id="element-146" data-mp="32060otrlpbm7">{t.pain}</span>
            <h3 className="ttit" data-id="element-147" data-mp="31ybezd8i9fh2">“{t.title}”</h3>
            <blockquote className="tq" data-id="element-148" data-mp="2x0jmoi3y7rcc">“{t.quote}”</blockquote>
            <figcaption className="tid" data-id="element-149" data-mp="2x11rw48l9fwe">
              <span className="tav" aria-hidden="true" data-id="element-150" data-mp="2s1yospc65jr2">
                {initials(t.name)}
              </span>
              <span data-id="element-151" data-mp="v9oojjm9rg2g">
                <b className="tname" data-id="element-152" data-mp="v85a7yk6bf3b">{t.name}</b>
                <span className="trole" data-id="element-153" data-mp="qac2h1382d0x">{t.role}</span>
              </span>
            </figcaption>
          </figure>)}
      </div>
      <p className="tnote" data-id="element-154" data-mp="h4wtpz4kg6gm">Depoimentos ilustrativos.</p>
    </section>;
}
function initials(name: string): string {
  return name.split(" ").filter(Boolean).map(w => w[0]).slice(0, 2).join("").toUpperCase();
}